module.exports = __webpack_public_path__ + "img/pic_无效.28d23e1c.png";